import { createStyles, Theme, Typography } from "@material-ui/core"
import ButtonBase from "@material-ui/core/ButtonBase"
import makeStyles from "@material-ui/core/styles/makeStyles"
import * as React from "react"
import { useState } from "react"
import { Redirect } from "react-router"
import { CCUtils } from "../../common/CCUtils"
import { ClassGrade } from "../../shared/models/Clazz"
import { Gender } from "../../shared/models/Gender"
import { FormWrapper } from "../generic-components/FormWrapper"
import { appTheme } from "../StyleUtils"
import { LoginRoutes } from "../WebApp"
import { LoginPage } from "./LoginPage"
import { BuddyName, StudentAccountStore } from "./StudentAccountStore"

interface BuddyImage {
    url: string
    name: BuddyName
    gender: Gender
}

const buddiesForGrade = (grade: ClassGrade): BuddyImage[] => {
    return [
        {
            url: require(`../../../assets/web/images/still-frame-${grade !== ClassGrade.SIXTH ? "" : "booster-"}girl.png`),
            name: BuddyName.GIRL,
            gender: Gender.GIRL,
        },
        {
            url: require(`../../../assets/web/images/still-frame-${grade !== ClassGrade.SIXTH ? "" : "booster-"}boy.png`),
            name: BuddyName.BOY,
            gender: Gender.BOY,
        },
    ]
}

const useStyles = makeStyles((theme: Theme) => (
    createStyles({
            root: {
                display: "grid",
                width: "100%",
                gridTemplateColumns: "1fr 1fr",
                gridGap: theme.spacing(4),
                padding: "0 10%"
            },
            image: {
                "width": "100%",
                "transition": "opacity 0.2s",
                "&:hover": {
                    opacity: 0.8
                }
            },
            label: {
                textAlign: "center"
            },
            focusVisible: {
                opacity: 0.8
            }
        }
    ))
)

export const StudentChooseBuddy = () => {
    const {root, image, label, focusVisible} = useStyles(appTheme)

    const [genderSelected, setGender] = useState<Gender>(StudentAccountStore.instance.gender)
    const [buddySaved, setBuddySaved] = useState(false)

    const saveBuddy = () => {
        StudentAccountStore.instance.gender = genderSelected
        setBuddySaved(true)
    }

    if (StudentAccountStore.instance.classCode === "") {
        return <Redirect to={LoginRoutes.joinClass}/>
    }

    if (buddySaved) {
        return <Redirect to={LoginRoutes.createScreenName} push={true}/>
    }

    const audioFile = CCUtils.asset("auth/register/choose-buddy.mp3")

    return (
        <LoginPage title={"Select a Buddy"} smallLogo={true}>
            <audio id="audio" src={audioFile} autoPlay/>
            <div style={{position: "relative", height: "100%"}}>
                <Typography variant={"body2"} style={{marginBottom: appTheme.spacing(4)}}>A buddy will be your guide throughout Click City. Do you want Isabella
                    or Lucas to be your buddy? Select the one you’d
                    like.
                </Typography>
                <FormWrapper buttonLabel={"Continue"} disabled={!genderSelected} onClick={saveBuddy}>
                    <div className={root}>
                        {buddiesForGrade(StudentAccountStore.instance.classGrade).map(({url, name, gender}) => (
                            <ButtonBase key={name} onClick={() => setGender(gender)} focusVisibleClassName={focusVisible} style={{display: "inline-block"}}>
                                <img
                                    src={url} alt={name} className={image}
                                    style={{
                                        filter: gender === genderSelected ? `drop-shadow(0px 5px 5px ${appTheme.palette.secondary.main})` : ""
                                    }}
                                />
                                <Typography
                                    variant={"subtitle1"}
                                    className={label}
                                    style={{
                                        color: gender === genderSelected ? appTheme.palette.primary.main : ""
                                    }}
                                >
                                    {name}
                                </Typography>
                            </ButtonBase>

                        ))}
                    </div>
                </FormWrapper>
            </div>
        </LoginPage>
    )
}